import { API, axiosInstance } from "lib";

export const getCategories = (data = {}) => {
  return axiosInstance
    .get(API.GET_CATEGORIES)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      throw err;
    });
};

export const addCategories = (data = {}) => {
  return axiosInstance
    .post(API.ADD_CATEGORIES, data)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};


export const addSubCategories = (data = {}) => {
  return axiosInstance
    .post(API.ADD_SUBCATEGORIES, data)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};


export const deleteCategories = (data = {}) => {
  return axiosInstance
    .post(API.DELETE_CATEGORIES, data)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};


export const deleteSubCategories = (data = {}) => {
  return axiosInstance
    .post(API.DELETE_SUBCATEGORIES, data)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};